// extracted by mini-css-extract-plugin
export default {"footer-details":"Footer_footer-details__bkP+l"};